export default __webpack_public_path__ + "static/media/vr-with-bg.d749c47f.png";